import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  /*
   * Regular Stimulus lifecycle methods
   * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
   *
   * If you intend to use this controller as a regular stimulus controller as well,
   * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
   *
   * Important:
   * By default, StimulusReflex overrides the -connect- method so make sure you
   * call super if you intend to do anything else when this controller connects.
   */
  static targets = ["hm0_output"];
  connect() {
    console.log("Règlement facture JS en cours ...");
    super.connect();
    console.log("Règlement facture JS en cours ...");

    if ($("#search").length && $("#quick_sort").length) {
      //on est sur la vue list
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });

      var targetElement = document.getElementById("mySidebar");
      targetElement.addEventListener("scroll", (event) => {
        var element = document.getElementById("mySidebar");
        document.getElementById("scrollevel").value = element.scrollTop;
      });

      const currentUrl = window.location.href;
      const url = new URL(currentUrl);
      const reglementFactureParam = url.searchParams.get("previous_record");

      if (reglementFactureParam != null) {
        var trElement = $("#reglements_facture_" + reglementFactureParam);
        $("#reglements_facture_" + reglementFactureParam + " td").addClass(
          "highlighted-td"
        );
        $("#reglements_facture_" + reglementFactureParam)
          .get(0)
          .scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
    if ($("#search").length && $("#quick_sort").length) {
      //on est sur la vue list
      if ($("#activate_em").length) {
        this.show_edition_multiple();
      }
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });
    }
  }
  update_compte_bancaire_url() {
    let facture_id = this.facture_st_id;
    console.log(facture_id);
    console.log(this.current_app);
    let url = $("#exporter_" + facture_id).attr("href");
    url =
      url +
      "&facture_st%5Bcompte_bancaire_id%5D=" +
      $("#compte_bancaire_" + facture_id + " :selected").val();
    $("#exporter_" + facture_id).attr("href", url);
    console.log("ICIIII");
  }

  get current_app() {
    return this.data.get("app");
  }

  get facture_st_id() {
    return this.data.get("facturestid");
  }
  beforeReflex(element, reflex, noop, reflexId) {}
  afterReflex(element, reflex, noop, reflexId) {}
}
